// extracted by mini-css-extract-plugin
export var fadeInOut = "_43-3";
export var icon = "_43-4";
export var savedIndicator = "_43-2";
export var savingIndicator = "_43-0";
export var spin = "_43-1";